// extracted by mini-css-extract-plugin
module.exports = {"itemList":"index_itemList__6ZKfF"};